import React, { Component } from 'react';
//import CheckboxTree from 'react-checkbox-tree';

import makeRequest from '../../../../requests/base.request'

/*
 =======================================================
Regras do filtro
======================================================
- Pode marcar apenas uma série
- Pode marcar multiplas turmas dentro da mesma série.
- Pode marcar apenas um aluno
 */

class FiltroSerieTurmaAluno extends Component {
    constructor(props) {
        super(props);
        this.state = this.getInitialState();

        this.onChangeSerie = this.onChangeSerie.bind(this);
        this.onChangeTurma = this.onChangeTurma.bind(this);
        this.onChangeAluno = this.onChangeAluno.bind(this);
        this.onClickToggleExpanded = this.onClickToggleExpanded.bind(this);
    }

    getInitialState() {
        const initialState = {
            serieSelecionada: undefined,
            turmasSelecionadas: [],
            alunoSelecionado: undefined,
            nodes: []
        };

        return initialState;
    }

    reset() {
        this.setState(this.getInitialState());
    }

    componentDidUpdate(prevProps) {
        // Typical usage (don't forget to compare props):
        // console.log('this.props.idEscola',this.props.idEscola)
        // console.log('prevProps.idEscola',prevProps.idEscola)
        if (this.props.idEscola !== prevProps.idEscola) {
            this.getSerieTurmaAlunos(this.props.idEscola);
        }
    }

    getSerieTurmaAlunos = async (idEscola) => {
        try {
            if (!idEscola) {
                await this.setState({
                    // treeViewData: {
                    //     checked: [],
                    //     expanded: [],
                    //     nodes: []
                    // },
                    nodes: []
                });
                return;
            }

            this.setState({ loading: true });

            const response = await makeRequest.get('escolas/alunos?school=' + idEscola) || [];
            //console.log(response);

            var treeViewDataNodes = this.mapToTreeViewNodes(response);
            //var treeViewData = { ...this.state.treeViewData, nodes: treeViewDataNodes };
            //await this.setState({ treeViewData: treeViewData, loading: false });

            var serieSelecionada = undefined;

            if(this.props.idSerie){
                serieSelecionada = this.props.idSerie;
            }

            await this.setState({ nodes: treeViewDataNodes || [], serieSelecionada: serieSelecionada, loading: false });
        } catch (error) {
            console.error(error)
        }
    }

    mapToTreeViewNodes(data) {
        var nodes = data.map(seg =>
            seg.grade.map(grade => ({
                //************** Série ******************/
                value: grade.idGrade,
                label: grade.txGrade + " " + seg.txAbbreviation,
                children: grade.classes.map(classes => ({

                    //************** Turma ******************/
                    value: classes.idEntityClass,
                    label: classes.txClass,
                    expanded: false,
                    children: classes.students.map(student => ({

                        //************** Aluno ******************/
                        value: student.idUser,
                        label: student.txStudentName
                    }))
                }))
            })))
            .reduce((memo, it) => (memo.concat(it)), [])

        return nodes;
    }

    onChangeSerie(serie) {
        this.setState({ serieSelecionada: serie, turmasSelecionadas: [], alunoSelecionado: undefined }, this.invokeOnChange);
    }

    onChangeTurma(turma,serie) {
        var turmas = this.state.turmasSelecionadas;

        if(serie !== this.state.serieSelecionada){
            turmas = [];
        }

        var turmaIdx = turmas.indexOf(turma);
        if(turmaIdx === -1){
            turmas.push(turma);
        }
        else{
            turmas.splice(turmaIdx,1)
        }

        this.setState({ turmasSelecionadas: turmas, serieSelecionada: serie, alunoSelecionado: undefined }, this.invokeOnChange);
    }

    onChangeAluno(aluno, turma, serie) {
        this.setState({ alunoSelecionado: aluno, turmasSelecionadas: [turma], serieSelecionada: serie }, this.invokeOnChange);
    }

    invokeOnChange() {
        if (this.props.onChange) {

            var descricao = "";
            var descricaoAluno = "";

            //Descrição: Serie - Turmas - Aluno
            var serie = this.state.nodes.find(item => item.value === this.state.serieSelecionada) || {};
            descricao = serie.label;

            var turmas = (serie.children || []).filter(item => this.state.turmasSelecionadas.indexOf(item.value) !== -1) || [];
            if(turmas.length > 0){
                var descricaoTurmas = turmas.map(item => item.label).join(", ");
                descricao += " - " + descricaoTurmas;
            }

            var aluno = ((turmas[0] || {}).children || []).find(item => item.value === this.state.alunoSelecionado) || {};
            if(aluno.label){
                descricaoAluno = aluno.label;
            }

            this.props.onChange(this.state.serieSelecionada, this.state.turmasSelecionadas, this.state.alunoSelecionado, descricaoAluno, descricao);
        }
    }

    onClickToggleExpanded(index, index2) {

        var nodes = this.state.nodes;
        if(index !== undefined && index2 === undefined){

            nodes[index].expanded = !nodes[index].expanded;
            this.setState({ nodes: nodes });
        }
        else if(index !== undefined && index2 !== undefined){

            nodes[index].children[index2].expanded = !nodes[index].children[index2].expanded;
            this.setState({ nodes: nodes });
        }
    }


    render() {
        let marcarApenasSeries = (this.props.marcarApenasSeries === undefined) ? false : this.props.marcarApenasSeries;

        return (<div className={"filtro-serie-turma-aluno " + this.props.className}>
            <strong>Segmento e turmas:</strong>
            <br />
            {this.state.loading && <div><small>Carregando...</small></div>}
            {!this.props.idEscola && <div><small>Selecione uma escola.</small></div>}
            {!this.state.loading && this.state.nodes.length === 0 && this.props.idEscola && <div><small>Nenhum item para a escola selecionada.</small></div>}

            {/* Infelizmente o componente de TreeView não conseguia atender todas as regras de marcação deste filtro, por isso escolheu-se a implementação manual */}
            {/* {!this.state.loading && <CheckboxTree
                nodes={this.state.treeViewData.nodes}
                checked={this.state.treeViewData.checked}
                expanded={this.state.treeViewData.expanded}
                onCheck={checked => this.setState({ treeViewData: { ...this.state.treeViewData, checked } })}
                onExpand={expanded => this.setState({ treeViewData: { ...this.state.treeViewData, expanded } })}
                showExpandAll={false}
                // nativeCheckboxes={true}
                noCascade={true}
                icons={{
                    //check: <i className="far fa-check-square" ></i>,
                    //uncheck: <i className="far fa-square" ></i>,
                    //halfCheck: <i className="far fa-minus-square" ></i>,
                    expandClose: <i className="fas fa-chevron-down"></i>,
                    expandOpen: <i className="fas fa-chevron-up"></i>,
                    parentClose: "",// <div style={{width:0}}></div>,
                    parentOpen: "",// <div style={{width:0}}></div>,
                    leaf: "",// <div style={{width:0}}></div>
                }}
            />} */}

            {!this.state.loading && this.state.nodes.map((itemSerie, indexSerie) =>
                <div key={`filtro-serie-${indexSerie}`}>

                    {/************* Séries ********************/}
                    <div>
                        {(itemSerie.children || []).length > 0 &&
                            <button className="edb-btn-link" onClick={() => this.onClickToggleExpanded(indexSerie)}>
                                {!itemSerie.expanded && <i className="fas fa-chevron-down adap-text-darkergray"></i>}
                                {itemSerie.expanded && <i className="fas fa-chevron-up adap-text-darkergray"></i>}
                            </button>
                        }

                        <label className="edb-margin-none-bottom edb-inline">
                            {!this.props.marcarApenasAlunos &&
                                <input type="radio" name="filtro-serie"
                                value={itemSerie.value}
                                checked={this.state.serieSelecionada === itemSerie.value}
                                onChange={() => this.onChangeSerie(itemSerie.value)} />
                            }
                        &nbsp;
                            <small>{itemSerie.label}</small>
                        </label>
                    </div>

                    {/************* Turmas ********************/}
                    {itemSerie.expanded && (itemSerie.children || []).map((itemTurma, indexTurma) =>
                        <div key={`filtro-turma-${indexSerie}${indexTurma}`}>

                            <div className="edb-margin-left">
                                {!this.props.esconderAlunos && (itemTurma.children || []).length > 0 &&
                                    <button className="edb-btn-link" onClick={() => this.onClickToggleExpanded(indexSerie, indexTurma)}>
                                        {!itemTurma.expanded && <i className="fas fa-chevron-down adap-text-darkergray"></i>}
                                        {itemTurma.expanded && <i className="fas fa-chevron-up adap-text-darkergray"></i>}
                                    </button>
                                }

                                <label className="edb-margin-none-bottom edb-inline">
                                    {!marcarApenasSeries && !this.props.marcarApenasAlunos &&
                                        <input type="checkbox" name="filtro-turma"
                                            value={itemTurma.value}
                                            checked={this.state.turmasSelecionadas.indexOf(itemTurma.value) !== -1}
                                            onChange={() => this.onChangeTurma(itemTurma.value, itemSerie.value)}
                                        />
                                    }
                                    &nbsp;
                                <small>{itemTurma.label}</small>
                                </label>
                            </div>

                            {/************* Alunos ********************/}
                            {!this.props.esconderAlunos && itemTurma.expanded && (itemTurma.children || []).map((itemAluno, indexAluno) =>
                                <label
                                    key={`filtro-aluno-${indexSerie}${indexTurma}${indexAluno}`}
                                    className="edb-margin-none-bottom edb-margin-large-left ">
                                        <input type="radio" name="filtro-aluno"
                                        value={itemAluno.value}
                                        checked={this.state.alunoSelecionado === itemAluno.value}
                                        onChange={() => this.onChangeAluno(itemAluno.value,itemTurma.value, itemSerie.value)}
                                        />
                                        &nbsp;
                                        <small>{itemAluno.label}</small>
                                </label>)}
                        </div>)}
                </div>

            )}



        </div>);
    }
}

export default FiltroSerieTurmaAluno;